(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmReferralSource', CrmReferralSource);

    CrmReferralSource.$inject = ['$resource'];

    function CrmReferralSource ($resource) {
        var resourceUrl =  'api/crm-referral-sources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
